import { inject, injectable } from "inversify";
import { ICriarWebserviceModel } from "../services/types";
import { EPluggyTypes } from "@/core/@types/types";
import { type WebserviceGateway } from "../services/ports/WebserviceGateway";

export interface IHandleWebservice {
  handleCriarWebservice(
    itemId: string,
    contaId: string,
    onErrorDisplayed: boolean
  ): Promise<void>;
}

@injectable()
export default class handleCriarWebservice implements IHandleWebservice {
  @inject(EPluggyTypes.CRIAR_WEBSERVICE)
  private webserviceGateway!: WebserviceGateway;

  private createWebserviceModel(
    itemId: string,
    contaId: string
  ): ICriarWebserviceModel {
    return {
      API: "203",
      ContaBancaria: contaId,
      ApiPluggy: {
        itemId: itemId
      }
    };
  }

  async handleCriarWebservice(
    itemId: string,
    contaId: string,
    onErrorDisplayed: boolean
  ): Promise<void> {
    const model = this.createWebserviceModel(itemId, contaId);

    await this.webserviceGateway.criarWebservice(model, onErrorDisplayed);
  }
}
